import React from 'react';
import { Navigate } from 'react-router-dom';
import useAuthStore from '../../store/authStore';

const PublicRoute = ({ children }) => {
  const { isAuthenticated, user } = useAuthStore();

  if (isAuthenticated) {
    // Redirigir al dashboard correspondiente según el rol
    switch (user?.rol) {
      case 'ADMIN':
      case 'SISTEMAS':
        return <Navigate to="/admin/dashboard" replace />;
      case 'SUPERVISOR':
        return <Navigate to="/supervisor/dashboard" replace />;
      case 'JEFE_SELECCION':
        return <Navigate to="/jefe-seleccion/dashboard" replace />;
      case 'ANALISTA':
        return <Navigate to="/analista/procesos" replace />;
      case 'RECLUTADOR':
        return <Navigate to="/reclutador/procesos" replace />;
      case 'POSTULANTE':
        return <Navigate to="/postulante/tests" replace />;
      default:
        return <Navigate to="/login" replace />;
    }
  }

  return children;
};

export default PublicRoute;
